module.exports = __webpack_public_path__ + "img/weddings_09_V.cee9da56.webp";